import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=0640d0d0&scoped=true"
import script from "./PersonalDetails.vue?vue&type=script&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=0640d0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0640d0d0",
  null
  
)

export default component.exports